import { api } from './api';
import { EditorialInput, EditorialList, EditorialPost } from '../types/editorial';

const base = '/admin/editorial/posts';
export type EditorialAction = 'submit' | 'approve' | 'request-changes' | 'archive';

export const editorialService = {
  async importExisting(): Promise<{ imported: number; skipped: number }> {
    return (await api.post<{ imported: number; skipped: number }>(`${base}/import-existing`)).data;
  },
  async list(): Promise<EditorialList> {
    const first = (await api.get<EditorialList>(base, { params: { limit: 200 } })).data;
    let items = [...first.items];
    while (items.length < first.total) {
      const next = (await api.get<EditorialList>(base, { params: { skip: items.length, limit: 200 } })).data;
      if (next.items.length === 0) break;
      items = [...items, ...next.items];
    }
    return { ...first, items };
  },
  async get(id: string): Promise<EditorialPost> {
    return (await api.get<EditorialPost>(`${base}/${encodeURIComponent(id)}`)).data;
  },
  async create(input: EditorialInput): Promise<EditorialPost> {
    return (await api.post<EditorialPost>(base, input)).data;
  },
  async update(id: string, revision: number, input: EditorialInput): Promise<EditorialPost> {
    return (await api.patch<EditorialPost>(`${base}/${encodeURIComponent(id)}`, { ...input, revision })).data;
  },
  async act(id: string, revision: number, action: EditorialAction, note?: string): Promise<EditorialPost> {
    return (await api.post<EditorialPost>(`${base}/${encodeURIComponent(id)}/${action}`, {
      revision, ...(action === 'request-changes' ? { note } : {}),
    })).data;
  },
};
